import api from "./api";

export const getSends = (page) => {
  return api.get("admin/Send", {
    params: {
      page: page,
      limit: 5,
    },
  });
};

export const getSendsBySearch = (searchItem, search) => {
  return api.get(`admin/Send?searchItem=${searchItem}&search=${search}`);
};

export const getSendsByOrder = (item, direction) => {
  return api.get(`admin/Sends?order=${item}&direction=${direction}`);
};
